import AddressBar from './AddressBar.jsx';

export default AddressBar;


// WEBPACK FOOTER //
// ./src/components/AddressBar/index.jsx